import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { formatNOK } from "@/lib/format";

interface ActivateProjectDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  startupInvoicePct: number | null;
  totalAmount: number | null;
  onConfirm: (createInvoice: boolean) => void;
}

export function ActivateProjectDialog({
  open,
  onOpenChange,
  startupInvoicePct,
  totalAmount,
  onConfirm,
}: ActivateProjectDialogProps) {
  const pct = startupInvoicePct ?? 60;
  const total = Number(totalAmount ?? 0);
  const startupAmount = total * pct / 100;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader><DialogTitle>Aktiver prosjekt</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Prosjektet endres til <span className="font-medium text-foreground">Aktiv</span>. Vil du opprette oppstartsfaktura nå?
          </p>
          {startupInvoicePct != null && total > 0 && (
            <div className="rounded-lg border p-3 bg-muted/30">
              <p className="text-sm">Oppstartsfaktura: <span className="font-medium">{formatNOK(startupAmount)}</span> ({pct}% av {formatNOK(total)})</p>
            </div>
          )}
          <div className="flex gap-2 justify-end">
            <Button variant="outline" onClick={() => onConfirm(false)}>Aktiver uten faktura</Button>
            <Button onClick={() => onConfirm(true)}>Aktiver og opprett faktura</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
